import Vue from 'vue'
import { MessageBox } from 'element-ui'
import './common.css'
Vue.prototype.$customMessageBox = customMessageBox
export default customMessageBox

function customMessageBox (config) {
  MessageBox({
    title: '',
    message: '',
    customClass: 'message-box',
    closeOnClickModal: false,
    closeOnPressEscape: false,
    callback: async action => {
    },
    ...config
  })
}



// WEBPACK FOOTER //
// ./src/components/base/messageBox/index.js